import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function createNewCouplePatient({
  patient1,
  patient2,
  billingUser,
  patient1UserId,
  patient2UserId,
  billingType,
  waitlist,
  waitlistDateAdded,
  reasonForVisit,
  requestedTimes,
}: {
  patient1: ClientPortalPatient;
  patient2: ClientPortalPatient;
  billingUser: string;
  patient1UserId?: string | null;
  patient2UserId?: string | null;
  billingType?: string;
  waitlist?: boolean;
  waitlistDateAdded?: string;
  reasonForVisit?: string;
  requestedTimes?: {
    date: string;
    time: string;
  }[];
}) {
  const response = await fetchOrchidAPI("/api/users/v1/create_patient/couple", {
    method: "POST",
    body: JSON.stringify({
      billing_user: billingUser ? billingUser : "partner1",
      patient1_in: patient1,
      patient2_in: patient2,
      patient1_user_id: patient1UserId,
      patient2_user_id: patient2UserId,
      billing_type: billingType,
      waitlist,
      waitlist_date_added: waitlistDateAdded,
      reason_for_visit: reasonForVisit,
      requested_times: requestedTimes,
    }),
  });

  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return response.json();
}
